import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getMachine } from 'lib/selectors/getMachine';

import { actionSetFAIStatus } from 'lib/actions';
import { getCompany } from 'lib/selectors/getCompany';
import { getFAIEnabled } from 'lib/selectors/getFAIEnabled';
import { getLatestActivitySet } from 'lib/selectors/getLatestActivitySet';
import { FAISocket } from 'lib/api/websockets/FAISocket';

const useFAIData = () => {
  const dispatch = useDispatch();
  const machine = useSelector(getMachine);
  const company = useSelector(getCompany);
  const faiEnabled = useSelector(getFAIEnabled);
  const latestActivitySet = useSelector(getLatestActivitySet);

  const wooRef = latestActivitySet?.workOrderOperationRef;
  const companyId = company?.id;

  useEffect(() => {
    if (!faiEnabled || !machine.machineRef || !companyId || !wooRef) {
      return () => {};
    }

    const channel = new FAISocket({
      companyId,
      machineRef: machine.machineRef,
      workOrderOperationRef: wooRef,
    });

    channel.subscribe((data) => {
      if (Object.prototype.hasOwnProperty.call(data, 'currentInspection')) {
        dispatch(
          actionSetFAIStatus({
            currentInspection: data.currentInspection ?? null,
          })
        );
      }
    });

    return () => {
      channel.leave();
    };
  }, [dispatch, faiEnabled, machine.machineRef, wooRef, companyId]);
};

export { useFAIData };
